/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList200,
  GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList401,
  GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList500,
  GetApiV1CourseregistrationSharedMonographPresentationFinalStatusListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedMonographPresentationFinalStatusList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedMonographPresentationFinalStatusList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedMonographPresentationFinalStatusList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedMonographPresentationFinalStatusList500>;

export const getApiV1CourseregistrationSharedMonographPresentationFinalStatusListQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationSharedMonographPresentationFinalStatusList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedMonographPresentationFinalStatusListQueryResponse>;
